<template>
  <RouterView />
</template>

<style lang="postcss">
.wrapper {
  display: grid;
  grid-template-rows: auto 1fr;
  grid-auto-columns: 1fr;
  grid-auto-flow: row;
  overflow: hidden;

  .navbar-area {
    grid-area: navbar;
    z-index: 999;
  }

  .sidebar-area {
    grid-area: sidebar;
    z-index: 998;
  }

  .content-area {
    grid-area: content;
  }
}

@media (min-width: 1920px) {
  .wrapper {
    grid-template-columns: 0.17fr 1fr;
  }
}
</style>
